<template>
    <v-dialog v-model="dialog" persistent max-width="855px">
        <!-- Кнопка вызова КАКОГО ИМЕННО диалогового окна -->
        <div class="send-rate">
            <img class="send-rate__close-btn" src="/images/rates/close.svg" @click="close_modal()" />
            <div class="wrapper">
                <div class="departments_view__list">
                    <a
                        href="#"
                        v-for="department in rates"
                        :key="department._id"
                        @click="filter_rates_by_id(department.id)"
                    >
                        {{ department.name }}
                    </a>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {}
    },
    props: ['rates', 'dialog'],
    methods: {
        filter_rates_by_id(_id) {
            this.$emit('redirect', _id)
        },
        close_modal(){
            this.$emit('close_modal', false)

        }
    },
}
</script>

<style scoped>
    .departments_view {
        width: 907px;
        z-index: 1000;
        background: #f5f5f5;
        border: 1px solid #ed7428;
        box-sizing: border-box;
        border-radius: 30px;
        position: absolute;
        top: 0;
        left: 0;
        padding: 17px 30px 50px;
    }

    .departments_view__header span {
        font-style: normal;
        font-weight: normal;
        font-size: 22px;
        line-height: 26px;
        color: #1f0303;
        margin-right: 135px;
    }

    .departments_view__list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 40px;
    }

    .departments_view__list a {
        width: 266px;
        margin-bottom: 20px;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 130%;
        color: #1f0303;
        text-decoration: none;
    }

    .departments_view__list a:hover {
        text-decoration: underline;
    }
</style>